import { AlignmentType, HeadingLevel, IParagraphStylePropertiesOptions } from 'docx'
import { IStyleTemplateOptions } from './types'

const styleConfig = (paragraph: IParagraphStylePropertiesOptions): IStyleTemplateOptions => ({
  __templateName: 'modern',
  paragraphStyles: [
    {
      id: 'basicsContact',
      name: 'Contact',
      basedOn: 'Normal',
      paragraph: {
        alignment: AlignmentType.CENTER,
      },
      run: {
        italics: true,
      },
    },
    {
      id: 'basicsName',
      name: 'Name',
      basedOn: HeadingLevel.HEADING_1,
      paragraph: {
        alignment: AlignmentType.CENTER,
      },
    },
    {
      id: 'basicsLabel',
      name: 'Label',
      basedOn: HeadingLevel.HEADING_3,
      paragraph: {
        alignment: AlignmentType.CENTER,
      },
    },
  ],
  default: {
    heading1: {
      run: {
        font: 'Open Sans, sans-serif',
        size: 40,
        bold: true,
      },
    },
    heading2: {
      paragraph: {
        keepLines: true,
        keepNext: true,
      },
      run: {
        font: 'Open Sans, sans-serif',
        size: 24,
        bold: true,
      },
    },
    heading3: {
      run: {
        font: 'Open Sans, sans-serif',
        size: 24,
      },
    },
    document: {
      run: {
        font: 'Open Sans, sans-serif',
      },
      paragraph,
    },
  },
})

export default styleConfig
